import { ACTIONS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface ProductFilters {
    products?: string;
    category?: any;
    location?: any;
    status?: any;
    inventory?: any;
    stockCondition?: any;
    stockQty?: string;
    vendor?: any;
    tags?: any;
    productType?: any;
    brand?: any;
    displayOnMenu?: any;
    trackInventory?: any;
    eligibleForReturn?: any;
    ebt?: any;
    ageVerification?: any;
    productWithTagAlong?: any;
    isCasProduct?: any;
}

export interface ProductsReducer {
    products: any[] | null;
    filters: ProductFilters | null;
}

const initialState: ProductsReducer = {
    products: null,
    filters: null,
};

const productsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.PRODUCTS.SEARCH_PRODUCT:
            return {
                ...state,
                products: action.payload,
            };

        case ACTIONS.PRODUCTS.SET_PRODUCT_FILTERS:
            return {
                ...state,
                filters: action.payload,
            };

        case ACTIONS.PRODUCTS.CLEAR_PRODUCT_FILTERS:
            return {
                ...state,
                filters: null,
            };

        default:
            return state;
    }
};

export default productsReducer;
